import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp, Lock } from '@material-ui/icons';

const LockableSectionHeader = ({
    label,
    isActive,
    isOpen,
    titleVariant = 'h6',
    titleClassName = '',
    titleStyle = {},
    activeTitleColor = '#ED6628',
    inactiveTitleColor = '#b6b6b6',
    activeArrowColor = '#D35400',
    inactiveArrowColor = '#c8c8c8',
    rightNode = null,
    showChevron = true,
    showLockWhenInactive = true,
}) => (
    <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
        <Typography
            variant={titleVariant}
            className={titleClassName}
            style={{
                color: isActive ? activeTitleColor : inactiveTitleColor,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                ...titleStyle,
            }}
        >
            {label}
        </Typography>
        <Box display="flex" alignItems="center">
            {rightNode ? (
                rightNode
            ) : (
                <>
                    {!isActive && showLockWhenInactive && <Lock style={{ color: '#bdbdbd', fontSize: 16, marginRight: 4 }} />}
                    {showChevron && (isOpen ? (
                        <ArrowDropUp style={{ color: isActive ? activeArrowColor : inactiveArrowColor }} />
                    ) : (
                        <ArrowDropDown style={{ color: isActive ? activeArrowColor : inactiveArrowColor }} />
                    ))}
                </>
            )}
        </Box>
    </Box>
);

export default LockableSectionHeader;
